import { render, staticRenderFns } from "./PreviousPolicyODCoverDetails.vue?vue&type=template&id=bc38aad8&scoped=true"
import script from "./PreviousPolicyODCoverDetails.vue?vue&type=script&lang=js"
export * from "./PreviousPolicyODCoverDetails.vue?vue&type=script&lang=js"
import style0 from "./PreviousPolicyODCoverDetails.vue?vue&type=style&index=0&id=bc38aad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc38aad8",
  null
  
)

export default component.exports